import React from 'react';

export const TwitchIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5285_4471)">
        <path
          d="M6.25035 2.5L3.57178 5.17857V14.8214H6.78606V17.5L9.46463 14.8214H11.6075L16.4289 10V2.5H6.25035ZM15.3575 9.46429L13.2146 11.6071H11.0718L9.19678 13.4821V11.6071H6.78606V3.57143H15.3575V9.46429Z"
          fill="#9075D1"
        />
        <path d="M13.7504 5.44641H12.679V8.6607H13.7504V5.44641Z" fill="#9075D1" />
        <path d="M10.8041 5.44641H9.73267V8.6607H10.8041V5.44641Z" fill="#9075D1" />
      </g>
      <defs>
        <clipPath id="clip0_5285_4471">
          <rect width="15" height="15" fill="white" transform="translate(2.5 2.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
